import { Injectable } from '@angular/core';
import * as _ from "lodash";
import * as title from "../../config/title";
import * as legend from "../../config/legend";
import * as series from "../../config/series";
import * as toolbox from "../../config/toolbox";
import * as tooltip from "../../config/tootip";
import * as xAxis from "../../config/xAxis";
import * as yAxis from "../../config/yAxis";
import * as color from "../../config/colors";
import * as backgroundColor from "../../config/backgroundColor";
import * as datazoom from "../../config/datazoom";
import * as textStyle from '../../config/textStyle';
import { CommonService } from '../../service/common.service';
import { ECharts, EChartOption } from 'echarts';

@Injectable({
  providedIn: 'root'
})
export class LegendPieService {

  constructor(
    private commonService: CommonService
  ) { }

  style = this.commonService.changeFontSize();

  getDefaultOptionsOfLegendPieChart = () => {
    let style = this.commonService.changeFontSize()
    let defaultOptions = {
      title: title.getBottomTitle(style),
      backgroundColor: backgroundColor.backgroundColor,
      color: color.defaultColors,
      legend: legend.getLegendBottomScroll(style),
      // toolbox: toolbox.getToolboxBasicMenu(),
      tooltip: tooltip.getTooltipOfPieChart(style),
      series: series.getLegendPieChartSeries(style),
      textStyle: textStyle.getTextStyle()
    }
    return defaultOptions;
  }

  // 设置系列名
  changeSeriesName(chartOptions, string: string) {
    chartOptions.series[0].name = string;
  }

  // 更改饼图半径大小
  changeRadius(chartOptions, bcacPieChartRadius: string | number) {
    chartOptions.series[0].radius = bcacPieChartRadius;
  }
  // 更改饼图中心位置
  changeCenter(chartOptions, bcacPieChartCenter: Array<string> | Array<number>) {
    chartOptions.series[0].center = bcacPieChartCenter
  }

  // 更改图例位置
  changeLegendPosition(chartOptions, position) {
    let style = this.commonService.changeFontSize()
    switch (position) {

      case 'right':
        chartOptions.legend = legend.getLegendRightScroll(style)
        break;
      case 'top':
        chartOptions.legend = legend.getLegendNotShow(style)
        break;
      case 'none':
        chartOptions.legend = legend.getLegendNotShow(style);
        break;
      default:
        chartOptions.legend = legend.getLegendBottomScroll(style)
    }
    // console.log(chartOptions)
  }

  changeLegendShowStatus(chartOptions, showLegend: boolean) {
    // chartOptions.legend.show = showLegend;
  }

  // 设置饼图数据
  changeChartData(ChartOptions, chartData: any) {
    ChartOptions.series[0].data = chartData;
  }

  // 设置toolbox显示
  changeToolboxShow(chartOptions, show: boolean) {
    // chartOptions.toolbox.show = show
  }
  // 修改labelLine的长度
  changeLineLength(chartOptions, length: number) {
    chartOptions.series[0].labelLine.length = length;
  }
  // 修改labelLine2的长度
  changeLineLength2(chartOptions, length: number) {
    chartOptions.series[0].labelLine.length2 = length;
  }

  setLegendPosition(option: any, legendPosition: string) {
    if (legendPosition === "top") {
      option.grid = this.style.topLegendGrid;
      option.legend = legend.getTopLegend(this.style);
    } else if (legendPosition === "right") {
      option.grid = this.style.rightLegendGrid;
      option.legend = legend.getLegendRightScroll(this.style);
    } else if (legendPosition === 'none') {
      option.grid = this.style.noLegendGrid;
      option.legend = legend.getLegendNotShow(this.style);
    } else {
      //默认bottom
      option.grid = this.style.interval;
      option.legend = legend.getLegendBottomScroll(this.style);
    }
  }

  topLegendChange(legendDatas: any[], optionInit: ECharts) {
    legendDatas.forEach(e => {
      if (e.checked) {
        optionInit.dispatchAction({
          type: "legendSelect",
          name: e.value
        });
      } else {
        optionInit.dispatchAction({
          type: "legendUnSelect",
          name: e.value
        });
      }
    });
  }

  changeTitleOption(chartOptions, chartTitle: string) {

    chartOptions.title = title.getBottomTitle(this.style, true, chartTitle);
  }

  changeLabelShowStatus(chartOptions, labelShow) {
    if (typeof (labelShow) === 'string') {
      labelShow = JSON.parse(labelShow)
    }
    chartOptions.series[0].label.show = labelShow;
  }

  changeLabelType(chartOption, type: 'value' | 'percent') {
    if (type == "value") {
      chartOption.series.forEach(e => {
        e.label.formatter = "{b} : {c}"
      });
      chartOption.tooltip.formatter = (params) => {
        let str = '';
        str = '<span>' + params.seriesName + '<span><br/>'
        str += '<span style="color:' + params.color + '">' + params.marker + params.name + '：</span> <b>' + params.value + '</b><br/>'
        return str;
      }
    } else if (type == "percent") {
      chartOption.series.forEach(e => {
        e.label.formatter = (params) => {
          let str = '';
          str = params.name + " : " + params.percent.toFixed(1) + '%'
          return str
        }
      });
      chartOption.tooltip.formatter = (params) => {
        let str = '';
        str = '<span>' + params.seriesName + '<span><br/>'
        str += '<span style="color:' + params.color + '">' + params.marker + params.name + '：</span> <b>' + params.percent.toFixed(1) + '% </b><br/>'
        return str;
      }
    }

  }

  // 修改label对齐方式
  changeLabelAlignTo(chartOption, alignTo: 'none' | 'labelLine' | 'edge') {
    if (alignTo == 'edge') {
      chartOption.series[0].label.alignTo = alignTo;
    } else if (alignTo == 'labelLine') {
      chartOption.series[0].label.alignTo = alignTo;
    } else if (alignTo == 'none') {
      chartOption.series[0].label.alignTo = alignTo;
    }
  }

  // 修改label的边距
  changeLabelMargin(chartOption, margin: string | number) {
    chartOption.series[0].label.margin = margin;
  }

  // 修改label出血线的大小
  changeLabelBleedMargin(chartOption, bleedMargin: number) {
    chartOption.series[0].label.bleedMargin = bleedMargin;
  }

  changeMinAngle(chartOption, minAngle: number) {
    chartOption.series[0].minAngle = minAngle;
  }
}
